import { render, staticRenderFns } from "./AttributeStockFlowModal.vue?vue&type=template&id=67454019"
import script from "./AttributeStockFlowModal.vue?vue&type=script&lang=js"
export * from "./AttributeStockFlowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67454019')) {
      api.createRecord('67454019', component.options)
    } else {
      api.reload('67454019', component.options)
    }
    module.hot.accept("./AttributeStockFlowModal.vue?vue&type=template&id=67454019", function () {
      api.rerender('67454019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/attribute-stock/AttributeStockFlowModal.vue"
export default component.exports